import React from 'react';
import '../CSS/NursingJob.css';
import nursingJobHero from '../Images/services/Nursing Jobs in U.S/services-nursing-jobs-in-u.s..png';
import nursingJobHeroMob from '../Images/Mobile Images/services/Nursing Jobs in U.S/service-us-nursing-banner-image.png';
import { Button, TextField, Radio, RadioGroup, FormControlLabel, FormControl, FormLabel } from '@mui/material';
import { Link } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';

const NursingJob: React.FC = () => {
  const navigate = useNavigate();
  return (
    <div className="nursing-job-container">
      <div className="nursing-job-hero">
        <picture>
          <source media="(max-width: 1100px)" srcSet={nursingJobHeroMob} />
          <img src={nursingJobHero} alt="Nursing Job Hero" className="nursing-job-hero-img" />
        </picture>
        <div className="nursing-job-hero-content">
          <div className="nursing-job-hero-subtitle">Find yourself a new nursing Job in U.S.</div>
          <div className="nursing-job-hero-title">Achieve Your U.S. Nursing Dream with Confidence</div>
          <div className="nursing-job-hero-desc">
            Choose a partner—not just an agency—dedicated to your long-term career success.
          </div>
          <button onClick={() => navigate('/careers')} className="nursing-job-hero-btn">Apply Now</button>
        </div>
      </div>
      {/* Medwell360 Facts Section */}
      <div className="zemantics-health-facts">
        <div className="zemantics-health-facts-title">Why Choose Medwell360?</div>
        <Link to="/contact-us" className="zemantics-health-facts-contact-btn">Contact Us</Link>
        <div className="zemantics-health-facts-cards">
          <div className="zemantics-health-facts-card">
            <div className="zemantics-health-facts-card-title">We Prepare You</div>
            <div className="zemantics-health-facts-card-desc">We prepare you for the NCLEX with an accredited online platform, live teachers, transportation, and covered exam fees — all through Medwell360.</div>
          </div>
          <div className="zemantics-health-facts-card">
            <div className="zemantics-health-facts-card-title">We Cover Costs</div>
            <div className="zemantics-health-facts-card-desc">Don't worry about credentialing, immigration, or legal costs. We'll handle and pay for all of those fees, completely free of charge.</div>
          </div>
          <div className="zemantics-health-facts-card">
            <div className="zemantics-health-facts-card-title">We Place You</div>
            <div className="zemantics-health-facts-card-desc">Advance your career in leading U.S. Hospitals. You'll gain invaluable experience and opportunities for growth.</div>
          </div>
        </div>
      </div>
      {/* Apply Now Form Section */}
      <form className="apply-now-patient">
        <div className="apply-now-title-patient">Take the next step. Apply now!</div>
        <fieldset className="apply-now-fieldset-patient">
          <div className="apply-now-row-patient">
            <div className="apply-now-col-patient">
              <label htmlFor="firstName">First Name<span className="apply-now-required-patient">*</span></label>
              <TextField id="firstName" name="firstName" variant="outlined" required fullWidth size="medium" className="apply-now-input-patient" />
            </div>
            <div className="apply-now-col-patient">
              <label htmlFor="lastName">Last Name<span className="apply-now-required-patient">*</span></label>
              <TextField id="lastName" name="lastName" variant="outlined" required fullWidth size="medium" className="apply-now-input-patient" />
            </div>
          </div>
          <div className="apply-now-row-patient">
            <div className="apply-now-col-patient">
              <label htmlFor="email">Email<span className="apply-now-required-patient">*</span></label>
              <TextField id="email" name="email" type="email" variant="outlined" required fullWidth size="medium" className="apply-now-input-patient" />
            </div>
            <div className="apply-now-col-patient">
              <label htmlFor="phone">Phone<span className="apply-now-required-patient">*</span></label>
              <TextField id="phone" name="phone" type="tel" variant="outlined" required fullWidth size="medium" className="apply-now-input-patient" placeholder="+ 1" />
            </div>
          </div>
          <div className="apply-now-row-patient apply-now-row-radio-patient">
            <FormControl component="fieldset" style={{ width: '100%' }}>
              <FormLabel component="legend" className="apply-now-radio-label-patient" style={{ textAlign: 'left', width: '100%' }}>Are you a registered nurse?<span className="apply-now-required-patient">*</span></FormLabel>
              <RadioGroup row name="registeredNurse" className="apply-now-radio-group-patient">
                <FormControlLabel value="yes" control={<Radio />} label={<span className="apply-now-radio-text-patient">Yes</span>} />
                <FormControlLabel value="no" control={<Radio />} label={<span className="apply-now-radio-text-patient">No</span>} />
              </RadioGroup>
            </FormControl>
          </div>
        </fieldset>
        <Button type="submit" variant="contained" className="apply-now-submit-btn-patient">Submit</Button>
      </form>
    </div>
  );
};

export default NursingJob; 